import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgTargetSearch = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d="M11.6 14.23a2.85 2.85 0 1 0 0-5.7 2.85 2.85 0 0 0 0 5.7M2.75 9.54a8.99 8.99 0 0 1 6.79-6.79M13.5 2.75c3.37.76 6.03 3.41 6.79 6.79M9.54 20.29a9 9 0 0 1-6.79-6.79M20.29 13.5a9.02 9.02 0 0 1-6.79 6.79M17.99 17.97l3.66 3.65"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgTargetSearch);
export default ForwardRef;
